/*@ngInject*/
const FormReferencesController = function ($rootScope, $scope, $state, options, coreConstant, configurationMediator, localization, navigationStateModel) {

    localization.getTranslationsByKeys([this.translationsKey, 'formReferences']).then(function (translations) {

        $scope.viewModel = {
            title: options.title,
            cancelButton: options.cancelButtonLabel,
            okButton: options.confirmButtonLabel,
            buttonClass: options.showConfirmationButtons ? 'btn-success' : '',
            formReferencesMessage: options.summary,
            displayTypeColumn: false,
            displayStatusColumn: false,
            formParams: {
                key: 'name',
                sortType: 'asc'
            }
        };

        $scope.onSort = function (event, params) {
            $scope.viewModel.formParams = params;
            $scope.viewModel.formReferenceList = _.orderBy($scope.viewModel.formReferenceList, [params.key], [params.sortType]);
        };

        $scope.getType = function (type) {
            return translations.type[type];
        };

        $scope.getStatus = function (status) {
            return translations.status[status];
        };

        $scope.onConfirm = function () {
            $scope.$close();
        };

        $scope.openFormTemplate = function (referenceUri) {
            var referenceArray = _.split(referenceUri, ':'),
                navigationModel = {};

            if (_.endsWith(referenceArray[0], 'UIFormTemplate')) {
                navigationModel = {
                    parentState: 'configuration.formTemplateBrowser',
                    currentState: 'configuration.formEditor.form',
                    data: {
                        uiFormTemplateId: referenceArray[1]
                    }
                };
                $state.go('configuration.formEditor.form', {uiFormTemplateId: referenceArray[1]});
                navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
                $scope.$dismiss();
            }
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.init = function () {
            $scope.viewModel.formReferenceList = _.orderBy(options.formReferenceList, [$scope.viewModel.formParams.key], [$scope.viewModel.formParams.sortType]);
            _.each($scope.viewModel.formReferenceList, function (formReference) {
                if (!_.isNil(formReference.type)) {
                    $scope.viewModel.displayTypeColumn = true;
                }
                if (!_.isNil(formReference.status)) {
                    $scope.viewModel.displayStatusColumn = true;
                }
            });
        };

        $scope.init();
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('formReferencesController', FormReferencesController);
